var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('balance-view',{attrs:{"loading":_vm.loading,"enableScroll":_vm.enableScroll,"balance":_vm.balance,"transactionsList":_vm.transactionsList},on:{"next":_vm.getNextData}})}
var staticRenderFns = []

export { render, staticRenderFns }